export function getTZOffset() {
  return new Date().getTimezoneOffset()
}
